Drupal.behaviors.mpp_custom_aerin_mobile_v1 = {
  attach: function (context, settings) {
    var productsData = page_data['custom-mpp'].products;
    site.productView.mpp.init(productsData);
    //product sort
    site.productSort.init(productsData);
  }
};